import React, { Component } from 'react';
import { Row, Col, Form } from "react-bootstrap";
import { Button } from "../common";
import './forgetPassword.scss';

/*-- Import required components --*/
import Timer from './../loginView/Timer';
import { get, post } from './../../utility/apiClient';
import { errorTypesEnum } from './../../utility/enums';
import KeellsLogo from '../../assets/img/logo/KeellsWhiteLogo.png';
import { checkPasswordComplexity } from '../../utility/commonFunctions';
import { EncryptString } from '../../utility/security';

/**-- Imports for redux --*/
import { connect } from 'react-redux';
import { showMessageBox } from '../../redux/actions/messageBoxActions';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';

// map the redux states to props
function mapStateToProps(state) {
    return {
        responsive: state.responsive,
        loadingScreenVisible: state.loadingScreen,
        userDetails: state.userDetails
    }
};

// map the redux actions to props
const mapDispatchToProps = {
    showMessageBox,
    showLoadingScreen,
    hideLoadingScreen,
};

/**
 * Date     :   2020-06-22
 * Author   :   Dinushka Rukshan
 * Remarks  :   Forget password page to change the password
 */
class ForgetPassword extends Component {
    constructor(props) {
        super(props)

        this.state = {
            customerID: 0,
            email: "",
            emailError: "",
            verifyEmail: "",
            verifyMobile: "",
            verifyCode: "",
            verifyCodeError: "",
            verifyReference: "",
            password: "",
            passwordError: "",
            confirmPassword: "",
            confirmPasswordError: "",
            selectedVerifyOption: 0, //1:Email & 2:Mobile
            verifyOptionError: "",
            visibleVerifySection: false,
            requestVerifyCode: false,
            isDisabledResend: true,
            isOTPValidate: false,
            visiblePasswordSection: false,
            timerKey: 0,
            forgetPasswordText: "",
            afterSendOTPDisplayMessage: "",
        }
    };

    componentDidMount() {
        if (this.props.userDetails.customerID > 0 && !this.props.userDetails.migrationVerified) {
            this.setState({
                email: this.props.userDetails.email,
                forgetPasswordText: "We heard you, and we have made it better! Before you start, please reset your password to continue shopping."
            }, () => {
                this.checkEmailAddress();
            })
        } else {
            this.setState({
                forgetPasswordText: "Please verify your details and change the password."
            })
        }
    }

    onChangeSetState = event => {
        this.setState({ [event.target.name]: event.target.value });
        if (event.target.name == "email") {
            this.setState({
                emailError: "",
                customerID: 0,
                verifyEmail: "",
                verifyMobile: "",
                visibleVerifySection: false
            });
        }
        else if (event.target.name == "password") {
            this.setState({ passwordError: "" });
        }
        else if (event.target.name == "confirmPassword") {
            this.setState({ confirmPasswordError: "" });
        }
        else if (event.target.name == "verifyCode") {
            this.setState({ verifyCodeError: "" });
        }
    };

    verifyOptionRadioBtnChange = event => {
        if (event) {
            this.setState({
                verifyOptionError: "",
                selectedVerifyOption: (event.target.id === "verify_by_email" && event.target.checked) ? 1 : 2
            })
        }
    };

    handleInputBlur = event => {
        this.validateInputFields("email");
    };

    validateInputFields(param) {
        let isValid = true;
        if (param === "email") {
            if (!(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(this.state.email)) {
                this.setState({
                    emailError: (this.state.email === '' || this.state.email === null) ? 'Email is required.' : 'Invalid email address.'
                });
                isValid = false;
            }
        } else if (param === "verifyOption") {
            if (this.state.selectedVerifyOption === 0) {
                this.setState({
                    verifyOptionError: "Verify option is required."
                });
                isValid = false;
            }
        } else if (param === "verificationCode") {
            if (this.state.verifyCode === null || this.state.verifyCode === "") {
                this.setState({
                    verifyCodeError: "Verification code is required."
                })
                isValid = false;
            } else {
                this.setState({ verifyCodeError: "" })
            }
        } else if (param === "password") {
            var response = checkPasswordComplexity(this.state.password);
            if (!response.result) {
                this.setState({ passwordError: response.error })
                isValid = false;
            } else {
                if (this.state.confirmPassword === null || this.state.confirmPassword === "") {
                    this.setState({
                        confirmPasswordError: "Confirm password is required."
                    })
                    isValid = false;
                }
                if (!(this.state.confirmPassword === null || this.state.confirmPassword === "") && (this.state.password != this.state.confirmPassword)) {
                    this.setState({
                        confirmPasswordError: "Confirm password does not match."
                    })
                    isValid = false;
                }
            }
        }

        return isValid;
    };

    checkEmailAddress() {
        if (this.validateInputFields("email")) {
            let formData = new FormData();
            formData.append('username', this.state.email);
            this.props.showLoadingScreen();
            post(`/Password/CheckUsername`, formData).then(response => {
                if (response.data.statusCode === 200) {
                    if (response.data.result.customerID === 0) {
                        let messageBox = {
                            show: true,
                            title: "Oops!",
                            className: "error",
                            content: "Email address does not exist",
                            isConfirmation: false,
                            callBackFunction: null
                        }
                        this.props.showMessageBox(messageBox);
                    } else {
                        this.setState({
                            customerID: response.data.result.customerID,
                            verifyEmail: response.data.result.email,
                            verifyMobile: response.data.result.mobileNumber,
                            visibleVerifySection: true
                        })
                    }
                } else {
                    let errorType = response.data.errorList[0].errorType;
                    let messageBox = {
                        show: true,
                        title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                        className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
                this.props.hideLoadingScreen();
            })
        }
    };

    requestVerifyCode() {
        if (this.validateInputFields("verifyOption")) {
            this.props.showLoadingScreen();
            let isEmailAddress = this.state.selectedVerifyOption === 1 ? true : false;
            let isMobileNumber = this.state.selectedVerifyOption === 2 ? true : false;
            let encryptedUserName = EncryptString(this.state.email);
            let formData = {
                Username: encryptedUserName,
                IsMobileNumber: isMobileNumber,
                IsEmail: isEmailAddress,
                Reference: this.state.verifyReference
            }
            post(`/Password/SendPasswordResetOTP`,formData).then(response => {
                if (response.data.statusCode === 200) {
                    this.setState({
                        requestVerifyCode: true,
                        timerKey: this.state.timerKey + 1,
                        verifyReference: response.data.result.otpKey,
                        afterSendOTPDisplayMessage: isEmailAddress ? "Please check your email to find your verification code" : "Please check your mobile to find your verification code"
                    })
                } else {
                    let errorType = response.data.errorList[0].errorType;
                    let messageBox = {
                        show: true,
                        title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                        className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
                this.props.hideLoadingScreen();
            })
        }
    };

    verifyOtpNumber() {
        if (this.validateInputFields("verificationCode")) {
            this.props.showLoadingScreen();
            get(`/Password/ValidatePasswordResetOTP?reference=${this.state.verifyReference}&otp=${this.state.verifyCode}`).then(response => {
                if (response.data.statusCode === 200) {
                    if (response.data.result) {
                        this.setState({
                            isOTPValidate: true,
                            visibleVerifySection: false,
                            visiblePasswordSection: true
                        })
                    } else {
                        this.setState({
                            isOTPValidate: false,
                            visibleVerifySection: true,
                            visiblePasswordSection: false,
                            verifyCodeError: "Invalid Verification Code"
                        })
                    }
                } else {
                    let errorType = response.data.errorList[0].errorType;
                    let messageBox = {
                        show: true,
                        title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                        className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
                this.props.hideLoadingScreen();
            })
        }
    };

    updateNewPassword() {
        if (this.validateInputFields("password")) {
            let formData = {
                CustomerID: this.state.customerID,
                Password: this.state.password
            };
            this.props.showLoadingScreen();
            post(`/Password/ResetPassword`, formData).then(response => {
                if (response.data.statusCode === 200) {
                    if (response.data.result) {
                        let messageBox = {
                            show: true,
                            title: "Password change successful",
                            className: "success",
                            content: response.data.errorList[0].statusMessage,
                            isConfirmation: false,
                            callBackFunction: () => { window.location.href = "/welcome/Login"; }
                        }
                        this.props.showMessageBox(messageBox);
                    }
                } else {
                    let errorType = response.data.errorList[0].errorType;
                    let messageBox = {
                        show: true,
                        title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                        className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
                this.props.hideLoadingScreen();
            })
        }
    };

    passwordVisibility(param) {
        if (param === "PW") {
            var passwordField = document.getElementById("forgetPassword");
            var pwVisibleIcon = document.getElementById("forget_pw_visible_icon");
            if (passwordField.type === "password") {
                passwordField.type = "text";
                pwVisibleIcon.classList.replace("fa-eye-slash", "fa-eye");
            } else {
                passwordField.type = "password";
                pwVisibleIcon.classList.replace("fa-eye", "fa-eye-slash");
            }
        } else {
            var confirmPWField = document.getElementById("forgetConfirmPassword");
            var pwVisibleIcon = document.getElementById("forget_cpw_visible_icon");
            if (confirmPWField.type === "password") {
                confirmPWField.type = "text";
                pwVisibleIcon.classList.replace("fa-eye-slash", "fa-eye");
            } else {
                confirmPWField.type = "password";
                pwVisibleIcon.classList.replace("fa-eye", "fa-eye-slash");
            }
        }
    };

    render() {
        return (
            <Col className={`login-container ${this.props.isVisible ? '' : 'd-none'}`} lg="10" md="10" sm="12" xs="12">
                <div className='gray-section'>
                    <Col className='pb-4'>
                        <img src={KeellsLogo} className="img-fluid" /> <br /> <br />
                        <span className='small-title white'>Reset Password</span>
                        <br />  <br />
                        <span className={`description white`}>
                            {this.state.forgetPasswordText}
                        </span>
                        <br />  <br />
                        <span className={`description ${1 === 1 ? 'white' : 'green'}`}>
                            Important: Note that only the last 5 carts shopped on www.keellssuper.com in the last 2 years will be reflected on the new site.
                            </span>
                    </Col>
                </div>

                <div className='second-section'>
                    <Col>
                        <div className="form-group">
                            <label htmlFor="Email" className='white'>Email</label>
                            <div className="input-group">
                                <input id="email" name="email" placeholder="Email" type="text" disabled={this.state.isOTPValidate} onChange={this.onChangeSetState.bind(this)}
                                    onBlur={this.handleInputBlur.bind(this)} className="form-control set-height-55 no-left-border" required="required" value={this.state.email} />
                                <Button primary floatRight appendToTextBox disabled={this.state.isOTPValidate} onClick={this.checkEmailAddress.bind(this)}>
                                    Submit
                                        </Button>
                            </div>
                            <span className={`form-text text-muted col`}>{this.state.emailError}</span>
                        </div>
                    </Col>
                    <Col style={{ display: this.state.visibleVerifySection ? 'block' : 'none' }}>
                        <div className="form-group">
                            <label htmlFor="verifyOption" className='white'>Verify Option</label>
                            <div key={`inline-radio`} className="white">
                                <Form.Check name="radio-group-verify" inline label={`Email - ${this.state.verifyEmail}`} type='radio' id={`verify_by_email`}
                                    style={{ marginRight: "30px" }} style={{ display: this.state.verifyEmail === "" ? 'none' : 'block' }} onChange={this.verifyOptionRadioBtnChange.bind(this)} />
                                <Form.Check name="radio-group-verify" inline label={`Mobile - ${this.state.verifyMobile}`} type='radio' id={`verify_by_mobile`}
                                    style={{ display: this.state.verifyMobile === "" ? 'none' : 'block' }} onChange={this.verifyOptionRadioBtnChange.bind(this)} />
                            </div>
                            <span className={`form-text text-muted col`}>{this.state.verifyOptionError}</span>
                        </div>
                    </Col>
                    <Col style={{ display: this.state.visibleVerifySection ? 'block' : 'none' }}>
                        <div className="form-group" style={{ marginTop: "6px" }}>
                            <Button disabled={(this.state.requestVerifyCode && this.state.isDisabledResend && this.state.selectedVerifyOption === 2)}
                                onClick={this.requestVerifyCode.bind(this)}
                                primary>{this.state.verifyReference !== "" ? "Resend" : "Verify"}</Button>
                        </div>
                    </Col>
                    <Col style={{ display: this.state.visibleVerifySection ? 'block' : 'none' }}>
                        {
                            (this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen) ?

                                <div className="form-group">
                                    <label className='white' htmlFor="VerificationCode">Verification Code</label>
                                    <div className={`input-group to-center`}>
                                        {this.state.isOTPValidate ? <i className='fas fa-check-circle done-icon otp-done-icon' /> : null}
                                        <input
                                            disabled={!this.state.requestVerifyCode || this.state.isOTPValidate}
                                            autoComplete='off'
                                            maxLength={4}
                                            minLength={4}
                                            onChange={this.onChangeSetState.bind(this)}
                                            id="verifyCode" name="verifyCode" placeholder="Verification Code" type="text"
                                            value={this.state.verifyCode}
                                            className={`form-control`} />
                                        {
                                            ((this.state.isOTPValidate || !this.state.requestVerifyCode) || (this.state.selectedVerifyOption === 1)) ? null
                                                : <Timer
                                                    color='white'
                                                    key={this.state.timerKey}
                                                    minutes={2}
                                                    seconds={0}
                                                    enableTimer={this.state.requestVerifyCode}
                                                    callForResend={() => { this.setState({ isDisabledResend: false, verifyCode: "", requestVerifyCode: false }) }}
                                                />
                                        }
                                        <span className={`form-text text-muted col`}>{this.state.verifyCodeError}</span>
                                        <span className='green'>{this.state.afterSendOTPDisplayMessage}</span>

                                        <Button secondary onClick={this.verifyOtpNumber.bind(this)}
                                            disabled={!this.state.requestVerifyCode || this.state.isOTPValidate}
                                        >Submit</Button>
                                    </div>
                                </div>
                                :
                                <div className="form-group">
                                    <label className='white' htmlFor="VerificationCode">Verification Code</label>
                                    <div className={`input-group to-center`}>
                                        <Row style={{ width: '100%' }}>
                                            <Col lg={5}>
                                                {this.state.isOTPValidate ? <i className='fas fa-check-circle done-icon otp-done-icon' /> : null}
                                                <input
                                                    disabled={!this.state.requestVerifyCode || this.state.isOTPValidate}
                                                    style={{ marginBottom: 10 }}
                                                    autoComplete='off'
                                                    maxLength={4}
                                                    minLength={4}
                                                    onChange={this.onChangeSetState.bind(this)}
                                                    id="verifyCode" name="verifyCode" placeholder="Verification Code" type="text"
                                                    value={this.state.verifyCode}
                                                    className={`form-control set-height-55`} />
                                                {
                                                    ((this.state.isOTPValidate || !this.state.requestVerifyCode) || (this.state.selectedVerifyOption === 1)) ? null
                                                        : <Timer
                                                            color='white'
                                                            key={this.state.timerKey}
                                                            minutes={2}
                                                            seconds={0}
                                                            enableTimer={this.state.requestVerifyCode}
                                                            callForResend={() => { this.setState({ isDisabledResend: false, verifyCode: "", requestVerifyCode: false }) }}
                                                        />
                                                }
                                                <span className={`form-text text-muted col`}>{this.state.verifyCodeError}</span>
                                                <span className='green'>{this.state.afterSendOTPDisplayMessage}</span>
                                            </Col>
                                            <Col lg={6} >
                                                <Button secondary onClick={this.verifyOtpNumber.bind(this)}
                                                    disabled={!this.state.requestVerifyCode || this.state.isOTPValidate}
                                                >Submit</Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                        }
                    </Col>
                    <Col style={{ display: this.state.visiblePasswordSection ? '' : 'none' }}>
                        <div className='form-group'>
                            <label htmlFor="Password" className='white'>New Password</label>
                            <div className="input-group" style={{ marginBottom: 0 }}>
                                <input id="forgetPassword" name="password" placeholder="Password" type="password" value={this.state.password}
                                    onChange={this.onChangeSetState.bind(this)} className="form-control set-height-55" aria-describedby="PasswordHelpBlock" />
                                <i id="forget_pw_visible_icon" className="fas fa-eye-slash" onClick={this.passwordVisibility.bind(this, "PW")} />
                            </div>
                            <span className={`form-text text-muted col`}>{this.state.passwordError}</span>
                        </div>
                        <div className='form-group'>
                            <label htmlFor="Confirm Password" className='white'>Confirm New Password</label>
                            <div className="input-group" style={{ marginBottom: 0 }}>
                                <input id="forgetConfirmPassword" name="confirmPassword" placeholder="Confirm Password" type="password" value={this.state.confirmPassword}
                                    onChange={this.onChangeSetState.bind(this)} className="form-control set-height-55" aria-describedby="PasswordHelpBlock" />
                                <i id="forget_cpw_visible_icon" className="fas fa-eye-slash" onClick={this.passwordVisibility.bind(this, "CPW")} />
                            </div>
                            <span className={`form-text text-muted col`}>{this.state.confirmPasswordError}</span>
                        </div>
                    </Col>
                    <Col style={{ display: this.state.visiblePasswordSection ? 'block' : 'none' }}>

                        <div className="form-group text-muted forget-pw-guideline">
                            <i className="fas fa-info-circle"></i> Your password must contain a minimum of 8 characters with 1 Uppercase, Numeric & Special character.
                                </div>

                    </Col>
                    <br />
                    <Col style={{ display: this.state.visiblePasswordSection ? 'block' : 'none' }}>
                        <div className='input-group'>
                            <Button onClick={this.updateNewPassword.bind(this)} primary>
                                Submit
                                    </Button>
                        </div>
                    </Col>
                </div>

            </Col>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgetPassword);
